import React from "react";
import SubmitAnimation from "../../../../assets/submit.svg";
import styles from "./loadingButton.module.css";

function LoadingButton({ text, isLoading, onClick, loadingText, ...props }) {
  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={onClick}
      style={{ height: "38px", ...props.style }}
      disabled={isLoading || props.isDisable}
      hidden={props.hidden}
    >
      <div className={`${styles.master}`}>
        <div className={`${styles.container}`}>
          {isLoading && (
            <img
              src={SubmitAnimation}
              alt="Submit animation"
              style={{ height: "100%" }}
            />
          )}
          <label>{isLoading ? loadingText : text}</label>
        </div>
      </div>
    </button>
  );
}

export default LoadingButton;
